export enum AttendingType {
  AUDIT = 'Auditoria',
  MAINTENANCE = 'Manutenção',
  INSTALLATION = 'Instalação'
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/constants/attending-type.ts